<template>
  <el-dialog :title="receiveData.title" visible class="Invoice-dialog" @close="closeDialog" width="40%" center>
    <el-form label-position="right" :rules="rules" label-width="100px" :model="invoiceInfo" ref="invoiceInfo">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label=" 上传发票：" prop="InvoiceImg" :rules="[
      { required: true, message: '发票不能为空'}
    ]">
            <el-button type="primary">上传文件</el-button>
            <input type="file" ref="uploadFile" class="upload-file" @change="uploadFile">
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <h5 class="preview-title">预览区域（请上传小于5M的图片）</h5>
          <img :src="previewImg" alt="" class="preview-Img" @error="imgError">
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票金额：" prop="ActualAmount">
            <el-input type="text" v-model="invoiceInfo.ActualAmount" placeholder="请输入发票金额"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="票据号码：" prop="SourceInvoiceNumber">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" placeholder="请输入发票号码" v-model="invoiceInfo.SourceInvoiceNumber"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发票抬头：" prop="InvoiceHeader" :rules="[
      { required: true, message: '请填写发票抬头'},
    ]">
            <el-input placeholder="请输入发票抬头" v-model="invoiceInfo.InvoiceHeader"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="发票类型：">
            <el-select v-model="invoiceInfo.InvoiceType" placeholder="审核状态">
              <el-option label="普通发票" :value="0"></el-option>
              <el-option label="专用发票" :value="1"></el-option>
              <el-option label="个人" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="打款公司：">
            <el-select v-model="invoiceInfo.PaymentCompany" placeholder="选择打款公司">
              <el-option label="霍尔果斯巨掌互动科技有限公司" value="霍尔果斯巨掌互动科技有限公司"></el-option>
              <el-option label="天津掌上乐创科技有限公司" value="天津掌上乐创科技有限公司"></el-option>
              <el-option label="巨掌互动科技（北京）有限公司" value="巨掌互动科技（北京）有限公司"></el-option>
              <el-option label="北京掌动乐创科技有限公司" value="北京掌动乐创科技有限公司"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注：">
            <el-input type="textarea" v-model="invoiceInfo.BillingContent"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog">保 存</el-button>
    </span>
  </el-dialog>

</template>
<script>
import { uploadInvoiceImg } from "api/mediaWithdraw";
var PaymentCompany = [
  "霍尔果斯巨掌互动科技有限公司",
  "天津掌上乐创科技有限公司",
  "巨掌互动科技（北京）有限公司",
  "北京掌动乐创科技有限公司",
  "其他"
];
export default {
  data() {
    var validateActualAmount = (rule, value, callback) => {
      setTimeout(() => {
        if (isNaN(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0) {
            callback(new Error("请输入>0的数"));
          } else {
            if (value.split(".").length >= 2) {
              var num = value.split(".")[1].split('');
              if (num.length > 2) {
                callback(new Error("请保留两位小数"));
              } else {
                callback();
              }
            } else {
              callback()
            }
          }
        }

        // }
      }, 100);
    };
    var validateSourceInvoiceNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写发票号码"));
      }
      setTimeout(() => {
        var reg = /^[0-9]*$/;
        if (!reg.test(value)) {
          callback(new Error("发票号码必须为数字"));
        } else {
          callback();
        }
        // }
      }, 500);
    };
    return {
      invoiceInfo: {
        ActualAmount: "",
        InvoiceHeader: "",
        SourceInvoiceNumber: "",
        PaymentCompany: "",
        InvoiceType: 0,
        BillingContent: "",
        InvoiceImg: ""
      },
      rules: {
        ActualAmount: [
          { required: true, message: "金额不能为空！", trigger: "blur" },
          { validator: validateActualAmount, trigger: "blur" }
        ],
        SourceInvoiceNumber: [
          { validator: validateSourceInvoiceNumber, trigger: "blur" }
        ]
      },
      previewImg: ""
    };
  },
  props: {
    dialogPragram: Object,
    isShowdialog: Boolean
  },
  computed: {
    receiveData() {
      return this.dialogPragram;
    }
  },
  created() {
    this.initChangeData();
  },
  methods: {
    initChangeData() {
      if (this.dialogPragram.data) {
        this.previewImg = this.dialogPragram.data.InvoiceImg;
        for (var key in this.invoiceInfo) {
          this.invoiceInfo[key] = this.dialogPragram.data[key];
        }
        this.invoiceInfo["InvoiceId"] = this.dialogPragram.data["InvoiceId"];
      } else {
        this.previewImg = "";
        this.invoiceInfo = {
          ActualAmount: "",
          InvoiceHeader: "",
          SourceInvoiceNumber: "",
          PaymentCompany: "",
          InvoiceType: 0,
          BillingContent: "",
          InvoiceImg: ""
        };
      }
    },
    closeDialog() {
      this.$refs["invoiceInfo"].resetFields();
      this.$emit("close");
    },
    confirmDialog() {
      this.$refs["invoiceInfo"].validate(valid => {
        if (valid) {
          this.dialogPragram.callback(this.invoiceInfo);
        } else {
          return false;
        }
      });
    },
    // 上传图片
    uploadFile(e) {
      var invoiceTemplate = {
        ActualAmount: "发票金额",
        InvoiceHeader: "销售方名称",
        SourceInvoiceNumber: "发票号码",
        PaymentCompany: "受票方名称"
      };
      var obj = e.target.files[0];
      var fr = new FileReader();
      var that = this;
      fr.onload = function(e) {
        that.previewImg = e.target.result;
      };
      fr.readAsDataURL(obj);
      uploadInvoiceImg(e.target.files[0]).then(res => {
        this.$refs.uploadFile.value = "";
        this.invoiceInfo.InvoiceImg = res.Remark;
        if (res.InvoiceInfo) {
          var invoiceData = JSON.parse(res.InvoiceInfo).data;
          if (invoiceData) {
            for (var key in invoiceTemplate) {
              this.invoiceInfo[key] = invoiceData[invoiceTemplate[key]];
            }
            var temp = false;
            PaymentCompany.forEach(ele => {
              if (this.invoiceInfo["PaymentCompany"] === ele) {
                temp = true;
              }
            });
            if (!temp) {
              this.invoiceInfo["PaymentCompany"] = "其他";
            }
          } else {
            this.invoiceInfo.ActualAmount = "";
            this.invoiceInfo.InvoiceHeader = "";
            this.invoiceInfo.SourceInvoiceNumber = "";
            this.invoiceInfo.PaymentCompany = "";
          }
        }
      });
    },
    imgError() {
      this.previewImg = require("../../../common/img/b_img.png");
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";
.Invoice-dialog {
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
    .el-select {
      width: 100%;
    }
    .el-form-item {
      margin-bottom: 20px;
    }
  }
  .upload-file {
    opacity: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
  }
  .preview-title {
    text-align: center;
  }
  .preview-Img {
    display: block;
    height: 130px;
    margin: 10px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/add-invoice-dialog.vue